module.exports = __webpack_public_path__ + "img/orders.20b76f7b.svg";